class CustomEvents {
  constructor(vueGtm) {
    this.vueGtm = vueGtm;
  }

  static init(vueGtm) {
    return new CustomEvents(vueGtm);
  }

  post(event, eventData) {
    this.vueGtm.trackEvent({ event, eventData });
  }
}

export default CustomEvents;

